module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-76x76-6f84e7f4dee234c90d71afd76d6e107b.png";